/**
 * @author Adam Vlasek <adam.vlasek@styrax.cz>
 */

import React, { CSSProperties } from 'react';

interface ILabelProps {
    children: any
    htmlFor: string
    required?: boolean
    className?: string
    noRenderStar?: boolean
}

const STYLE: CSSProperties = { color: '#ed8b23' };

export const Required = () => <span style={STYLE}> *</span>;

const FormElementLabel = ({ className, children, htmlFor, required, noRenderStar }: ILabelProps) => (
    <label htmlFor={htmlFor} className={className || 'form-label'}>
        {children}{!noRenderStar && required && <Required />}
    </label>
);

export default FormElementLabel;
